import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Badge,
  Label,
  Button,
  UncontrolledTooltip,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
  Input,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import AdminHeader from "components/Headers/AdminHeader";
import {
  urlDecodedId,
  urlEncodedId,
} from "components/CommonComponents/encodeDecodeFunction";
import { ISOToHumanReadableDate } from "components/CommonComponents/CommonFunctions";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import { DEFAULT_RECORDS_PER_PAGE } from "components/constant";
import { getTraineeList, downloadTraineeQRCode } from "action/trainee";
import { useDispatch, useSelector } from "react-redux";
import { traineeList } from "constants/trainee";
import { NotificationContext } from "components/CommonComponents/NotificationProvider";
import { getChannelPartnerById } from "action/channelPartner";

export const trainee_list = [
  {
    id: 1,
    traineeName: "Amit Sharma",
    email: "amit.sharma@gmail.com",
    mobile: "9876543211",
    registeredAt: "2024-12-01T10:15:00",
    courses: ["Electric Vehicle Fundamentals", "EV Battery Technology"],
  },
  {
    id: 2,
    traineeName: "Neha Verma",
    email: "neha.verma@gmail.com",
    mobile: "9876543212",
    registeredAt: "2024-12-02T11:30:00",
    courses: ["Electrical Wiring Basics"],
  },
  {
    id: 3,
    traineeName: "Rohit Mehta",
    email: "rohit.mehta@gmail.com",
    mobile: "9876543213",
    registeredAt: "2026-01-03T09:45:00",
    courses: [
      "Electric Motor Repair",
      "Advanced EV Diagnostics",
      "EV Powertrain Systems",
    ],
  },
  {
    id: 4,
    traineeName: "Pooja Kulkarni",
    email: "pooja.k@gmail.com",
    mobile: "9876543214",
    registeredAt: "2026-01-04T14:10:00",
    courses: ["Electric Vehicle Fundamentals"],
  },
  {
    id: 5,
    traineeName: "Karan Malhotra",
    email: "karan.m@gmail.com",
    mobile: "9876543215",
    registeredAt: "2026-01-05T16:20:00",
    courses: ["EV Battery Technology", "EV Charging Infrastructure"],
  },
  {
    id: 6,
    traineeName: "Rahul Singh",
    email: "rahul.singh@gmail.com",
    mobile: "9876543216",
    registeredAt: "2026-01-06T10:05:00",
    courses: ["Electrical Safety & Standards", "Industrial Electrical Systems"],
  },
  {
    id: 7,
    traineeName: "Sneha Iyer",
    email: "sneha.iyer@gmail.com",
    mobile: "9876543217",
    registeredAt: "2026-01-07T12:40:00",
    courses: ["EV Diagnostics & Troubleshooting"],
  },
  {
    id: 8,
    traineeName: "Vikas Patel",
    email: "vikas.p@gmail.com",
    mobile: "9876543218",
    registeredAt: "2026-01-08T15:55:00",
    courses: ["Electric Motor Repair", "EV Power Electronics"],
  },
  {
    id: 9,
    traineeName: "Anjali Desai",
    email: "anjali.desai@gmail.com",
    mobile: "9876543219",
    registeredAt: "2026-01-09T09:25:00",
    courses: [
      "Electric Vehicle Fundamentals",
      "EV Charging Infrastructure",
      "EV Battery Technology",
    ],
  },
  {
    id: 10,
    traineeName: "Manish Gupta",
    email: "manish.g@gmail.com",
    mobile: "9876543220",
    registeredAt: "2025-12-10T11:50:00",
    courses: ["Electrical Wiring Basics"],
  },
  {
    id: 11,
    traineeName: "Ritu Saxena",
    email: "ritu.s@gmail.com",
    mobile: "9876543221",
    registeredAt: "2025-12-11T13:35:00",
    courses: ["EV Powertrain Systems", "Advanced EV Diagnostics"],
  },
  {
    id: 12,
    traineeName: "Sandeep Joshi",
    email: "sandeep.j@gmail.com",
    mobile: "9876543222",
    registeredAt: "2025-12-12T17:10:00",
    courses: ["Electric Vehicle Fundamentals", "EV Charging Infrastructure"],
  },
];

const initialState = {
  organizationName: {
    value: "ABC Pvt Ltd",
    error: "",
  },
  //contact person first name + last name
  contactPersonName: {
    value: "John Doe",
    error: "",
  },
  email: {
    value: "johndoe@example.com",
    error: "",
  },
  mobileNumber: {
    value: "9876543210",
    error: "",
  },
  gstNumber: {
    value: "22AAAAA0000A1Z5",
    error: "",
  },
  registeredAddressLine1: {
    value: "123 Business Street",
    error: "",
  },
  registeredAddressLine2: {
    value: "Suite 101, Nashik, Maharashtra 422001",
    error: "",
  },
  landmark: {
    value: "Near City Centre Mall",
    error: "",
  },
  panNumber: {
    value: "AAACH2702H",
    error: "",
  },
  state: {
    value: "Maharashtra",
    error: "",
  },
  city: {
    value: "Nashik",
    error: "",
  },
  pincode: {
    value: "422001",
    error: "",
  },
  companyLogo: {
    value: require("assets/img/brand/argon-react.png"),
    error: "",
  },
  supportingDocuments: {
    value: [
      {
        ID: 1,
        documentPath: "/sample-doc.pdf",
      },
      {
        ID: 2,
        documentPath: "/sample-doc.pdf",
      },
      {
        ID: 3,
        documentPath: "/sample-doc.pdf",
      },
      {
        ID: 4,
        documentPath: "/sample-doc.pdf",
      },
      {
        ID: 5,
        documentPath: "/sample-doc.pdf",
      },
    ],
    error: "",
  },

  accountStatus: {
    value: "ACTIVE",
    error: "",
  },
  createdOn: {
    value: "10-Dec-2024",
    error: "",
  },
};

function ChannelPartnerDetail() {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const { notify } = useContext(NotificationContext);
  const dispatch = useDispatch();
  const { id } = useParams();
  const decodedId = id ? urlDecodedId(id) : null;
  const [data, setData] = useState(initialState);
  const navigate = useNavigate();
  const [pageNum, setPageNum] = useState(1);
  const [isDownloading, setIsDownloading] = useState(false);
  const [searchState, setSearchState] = useState({
    searchName: "",
    searchEmail: "",
    searchMobile: "",
    filterParams: {
      filters: JSON.stringify([
        {
          field: "ChannelPartnerID",
          condition: "eq",
          filterValues: [String(decodedId)],
        },
      ]),
    },
  });

  const traineeDataList = useSelector((state) => state.trainees.traineeList);

  const fetchChannelPartnerDetails = async (id) => {
    const res = await getChannelPartnerById(id);

    if (res?.code !== 200 || !res.data) return;

    const d = res.data;

    setData({
      organizationName: {
        value: d.organizationName || "-",
        error: "",
      },

      contactPersonName: {
        value:
          `${d.userID?.firstName || ""} ${d.userID?.lastName || ""}`.trim(),
        error: "",
      },

      email: {
        value: d.userID?.email || "-",
        error: "",
      },

      mobileNumber: {
        value: d.userID?.mobile || "-",
        error: "",
      },

      gstNumber: {
        value: d.gstNo || "-",
        error: "",
      },

      panNumber: {
        value: d.panNo || "-",
        error: "",
      },

      registeredAddressLine1: {
        value: d.lineOne || "-",
        error: "",
      },

      registeredAddressLine2: {
        value: d.lineTwo || "-",
        error: "",
      },

      landmark: {
        value: d.landmark || "-",
        error: "",
      },

      state: {
        value: d.city?.state?.name || "-",
        error: "",
      },

      city: {
        value: d.city?.name || "-",
        error: "",
      },

      pincode: {
        value: d.pincode || "-",
        error: "",
      },

      companyLogo: {
        value: d.companyLogoImageURL || null,
        error: "",
      },

      supportingDocuments: {
        value: d.userDocuments || [],
        error: "",
      },

      accountStatus: {
        value: d.userID?.status || "INACTIVE",
        error: "",
      },

      createdOn: {
        value: d.createdAt || "-",
        error: "",
      },
    });
  };

  useEffect(() => {
    if (!decodedId) return;

    fetchChannelPartnerDetails(decodedId);
  }, [decodedId]);

  useEffect(() => {
    if (!decodedId) return;

    getTraineeList(dispatch, pageNum, searchState.filterParams);

    return () => {
      dispatch({ type: traineeList, payload: {} });
    };
  }, [dispatch, pageNum, decodedId, searchState.filterParams]);

  const formattedTraineeList = traineeDataList?.data?.trainee?.map(
    (item, index) => {
      return {
        ...item,
        srNo:
          (pageNum - 1) *
            (traineeDataList?.data?.noOfRecordsPerPage ||
              DEFAULT_RECORDS_PER_PAGE) +
          index +
          1,
        fullName: item?.user?.fullName || "",
        email: item?.user?.email || "",
        mobileNo: item?.user?.mobile || "",
        qrCode: item?.qrCodePath || "-",
        // status: item?.user?.status || "-",  //we can show this if needed
        createdOn: item?.user?.createdOn || "-",
      };
    },
  );

  const buildFilterParams = () => {
    const filterParams = [
      {
        field: "ChannelPartnerID",
        condition: "eq",
        filterValues: [String(decodedId)],
      },
    ];

    if (searchState.searchName.trim()) {
      filterParams.push({
        field: "FullName",
        condition: "match",
        filterValues: [searchState.searchName.trim()],
      });
    }

    if (searchState.searchEmail.trim()) {
      filterParams.push({
        field: "Email",
        condition: "like",
        filterValues: [searchState.searchEmail.trim()],
      });
    }

    if (searchState.searchMobile.trim()) {
      filterParams.push({
        field: "Mobile",
        condition: "like",
        filterValues: [searchState.searchMobile.trim()],
      });
    }

    return {
      filters: JSON.stringify(filterParams),
    };
  };

  const clearSearch = () => {
    setSearchState({
      searchName: "",
      searchEmail: "",
      searchMobile: "",
      filterParams: {
        filters: JSON.stringify([
          {
            field: "ChannelPartnerID",
            condition: "eq",
            filterValues: [String(decodedId)],
          },
        ]),
      },
    });

    if (pageNum !== 1) {
      setPageNum(1);
    }
  };

  const handleSearch = () => {
    if (
      !searchState.searchName.trim() &&
      !searchState.searchEmail.trim() &&
      !searchState.searchMobile.trim()
    ) {
      return;
    }

    const newFilterParams = buildFilterParams();

    if (
      JSON.stringify(searchState.filterParams) !==
      JSON.stringify(newFilterParams)
    ) {
      setSearchState((prev) => ({
        ...prev,
        filterParams: newFilterParams,
      }));

      if (pageNum !== 1) {
        setPageNum(1);
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const isFilterApplied =
    JSON.stringify(searchState.filterParams) !==
    JSON.stringify({
      filters: JSON.stringify([
        {
          field: "ChannelPartnerID",
          condition: "eq",
          filterValues: [String(decodedId)],
        },
      ]),
    });

  const downloadQR = async (trainee) => {
    setIsDownloading(true);
    try {
      const res = await downloadTraineeQRCode(trainee.ID);
      if (res.status === 200 && res.data) {
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1] ||
          "qr-code.png";

        const url = URL.createObjectURL(res.data);

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      } else if (res.code === 404) {
        notify(
          "danger",
          "The QR code for this trainee was not found. Please regenerate it.",
        );
      } else {
        notify(
          "danger",
          res?.message || "Failed to download QR code. Please try again.",
        );
      }
    } catch (error) {
      notify("danger", "Failed to download QR code. Please try again.");
    }
    setIsDownloading(false);
  };

  const column = [
    {
      Header: "Sr. No.",
      accessor: "srNo",
    },
    {
      Header: "Trainee Name",
      accessor: "fullName",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Mobile",
      accessor: "mobileNo",
    },
    {
      Header: "Enrolled Courses",
      id: "courses",
      disableSortBy: true,
      Cell: ({ row }) => {
        const courses = row.original.courses || [];
        const popoverId = `courses-${row.original.id}`;

        if (!courses.length) return <span className="text-muted">—</span>;

        return (
          <>
            <span
              id={popoverId}
              className="cursor d-inline-flex align-items-center text-primary"
            >
              {courses.length} Courses
              <i className="fa fa-info-circle ml-1 text-muted" />
            </span>

            <UncontrolledPopover
              target={popoverId}
              trigger="hover"
              placement="top"
            >
              <PopoverHeader>Enrolled Courses</PopoverHeader>

              <PopoverBody>
                <ul className="mb-0 pl-3">
                  {courses.map((course, i) => (
                    <li key={i}>{course}</li>
                  ))}
                </ul>
              </PopoverBody>
            </UncontrolledPopover>
          </>
        );
      },
    },
    {
      Header: "QR Code",
      accessor: "qrCode",
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <Button
            className="btn-link p-0"
            size="sm"
            disabled={isDownloading}
            onClick={() => downloadQR(row.original)}
          >
            <i className="fa-solid fa-download mr-1" />
            Download
          </Button>
        );
      },
    },
    {
      Header: "Registered On",
      accessor: "createdOn",
    },
    {
      Header: "Actions",
      disableSortBy: true,
      Cell: ({ row }) => {
        const traineeid = row.original.ID;
        const encodedTraineeID = traineeid ? urlEncodedId(traineeid) : null;

        return (
          <div className="actions-right d-flex justify-content-start align-items-center">
            {/* View */}
            <Button
              className="btn-link d-flex align-items-center p-0"
              id={`view${id}`}
              size="lg"
              onClick={(e) => {
                e.stopPropagation();
                navigate(
                  role === "SUPER_ADMIN"
                    ? `/super-admin/trainee/${encodedTraineeID}/details`
                    : `/admin/trainee/${encodedTraineeID}/details`,
                  {
                    state: {
                      channel: id,
                    },
                  },
                );
              }}
            >
              <i className="fa fa-eye mr-1 " />
            </Button>
            <UncontrolledTooltip delay={0} target={`view${id}`}>
              View
            </UncontrolledTooltip>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <AdminHeader />

      <Container fluid className="mt--6">
        <Row className="justify-content-center">
          <Col md="12">
            <Card>
              <CardHeader className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <i
                    className="fa fa-chevron-left cursor mr-2"
                    onClick={() =>
                      navigate(
                        role === "SUPER_ADMIN"
                          ? "/super-admin/channel-partner"
                          : "/admin/channel-partner",
                      )
                    }
                  />
                  <h3 className="mb-0">Channel Partner Details</h3>
                </div>

                <div className="d-flex justify-content-end">
                  <Button
                    className="btn-deep-blue"
                    color="default"
                    onClick={() =>
                      navigate(
                        role === "SUPER_ADMIN"
                          ? `/super-admin/channel-partner/edit/${id}`
                          : `/admin/channel-partner/edit/${id}`,
                        {
                          state: { mode: "edit" },
                        },
                      )
                    }
                  >
                    <i className="fa-solid fa-pencil mr-1"></i>
                    Edit
                  </Button>
                </div>
              </CardHeader>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Row className="g-3">
              <Col md="6">
                <Card className=" h-100">
                  <CardHeader>
                    <h4 className="mb-0">Basic Information</h4>
                  </CardHeader>

                  <CardBody>
                    <Row>
                      <Col md="6">
                        <div className="mb-3 d-flex flex-column align-items-start ">
                          <Label className="small-label text-muted mb-1">
                            Organization Name
                          </Label>
                          <small className="small-text">
                            {data.organizationName.value}
                          </small>
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="mb-3 d-flex flex-column align-items-start ">
                          <Label className="small-label text-muted mb-1">
                            Contact Person
                          </Label>
                          <small className="small-text">
                            {data.contactPersonName.value}
                          </small>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <div className="mb-3 d-flex flex-column align-items-start mt-4">
                          <Label className=" small-label text-muted mb-1">
                            Email
                          </Label>
                          <small className="small-text">
                            {data.email.value}
                          </small>
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="mb-3 d-flex flex-column align-items-start mt-4">
                          <Label className="small-label text-muted mb-1">
                            Mobile Number
                          </Label>
                          <small className="small-text">
                            {data.mobileNumber.value}
                          </small>
                        </div>
                      </Col>
                      <Col md="12">
                        <div className="mt-3">
                          <Label className="small-label text-muted mb-1">
                            Status
                          </Label>
                          <div>
                            <Badge
                              color={
                                data.accountStatus.value === "ACTIVE"
                                  ? "success"
                                  : "warning"
                              }
                              className="badge-lg"
                            >
                              {data.accountStatus.value}
                            </Badge>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>

              <Col md="6">
                <Card className=" h-100">
                  <CardHeader className="bg-white">
                    <h4 className="mb-0">Business Information</h4>
                  </CardHeader>

                  <CardBody>
                    {/* Row 1 */}
                    <Row className="mb-3">
                      <Col md="6">
                        <div className="mb-3 d-flex flex-column align-items-start ">
                          <Label className="small-label text-muted mb-1">
                            PAN Number
                          </Label>
                          <small className="small-text">
                            {data.panNumber.value}
                          </small>
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="mb-3 d-flex flex-column align-items-start ">
                          <Label className="small-label text-muted mb-1">
                            GST Number
                          </Label>
                          <small className="small-text">
                            {data.gstNumber.value}
                          </small>
                        </div>
                      </Col>
                    </Row>

                    {/* Row 2 */}
                    <Row className="mb-3">
                      <Col md="6">
                        <div className="mb-3 d-flex flex-column align-items-start">
                          <Label className="small-label text-muted mb-1">
                            Address Line 1
                          </Label>
                          <small className="small-text">
                            {data.registeredAddressLine1.value}
                          </small>
                          {/* <small className="small-text">
                            {data.registeredAddressLine2.value}
                          </small> */}
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="mb-3 d-flex flex-column align-items-start">
                          <Label className="small-label text-muted mb-1">
                            Address Line 2
                          </Label>
                          <small className="small-text">
                            {data.registeredAddressLine2.value}
                          </small>
                        </div>
                      </Col>
                    </Row>

                    {/* Row 3 */}
                    <Row>
                      <Col md="6">
                        <div className="mb-4-half d-flex flex-column align-items-start">
                          <Label className="small-label text-muted mb-1">
                            Landmark
                          </Label>
                          <small className="small-text">
                            {data.landmark.value}
                          </small>
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="mb-4-half d-flex flex-column align-items-start ">
                          <Label className="small-label text-muted mb-1">
                            City
                          </Label>
                          <small className="small-text">
                            {data.city.value}
                          </small>
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="mb-3 d-flex flex-column align-items-start ">
                          <Label className="small-label text-muted mb-1">
                            State
                          </Label>
                          <small className="small-text">
                            {data.state.value}
                          </small>
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="mb-3 d-flex flex-column align-items-start ">
                          <Label className="small-label text-muted mb-1">
                            Pincode
                          </Label>
                          <small className="small-text">
                            {data.pincode.value}
                          </small>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col md="12">
                <Card>
                  <CardHeader>
                    <h4 className="mb-0">Branding & Documents</h4>
                  </CardHeader>

                  <CardBody>
                    <Row>
                      {/* Company Logo */}
                      <Col md="4" sm="12">
                        <div className="mb-3">
                          <Label className="small-label text-muted mb-2 d-block">
                            Company Logo
                          </Label>

                          {data.companyLogo.value ? (
                            <div className="doc-preview-container">
                              <div className="doc-preview">
                                <img
                                  src={data.companyLogo.value}
                                  alt="Company Logo"
                                  className="doc-image"
                                />
                              </div>

                              <div className="doc-actions">
                                <Button
                                  color="link"
                                  size="sm"
                                  className="doc-action-btn"
                                  onClick={() =>
                                    window.open(
                                      data.companyLogo.value,
                                      "_blank",
                                    )
                                  }
                                >
                                  <i className="fa fa-eye mr-1" />
                                  View
                                </Button>
                              </div>
                            </div>
                          ) : (
                            <small className="text-muted">
                              No logo uploaded
                            </small>
                          )}
                        </div>
                      </Col>

                      {/* Supporting Documents */}
                      <Col md="8" sm="12">
                        <div className="mb-3">
                          <Label className="small-label text-muted mb-2 d-block">
                            Supporting Documents
                          </Label>

                          {data.supportingDocuments.value?.length > 0 ? (
                            <div className="d-flex flex-wrap">
                              {data.supportingDocuments.value.map(
                                (doc, index) => {
                                  const isPdf = doc.documentPath
                                    ?.toLowerCase()
                                    .endsWith(".pdf");

                                  return (
                                    <div
                                      key={index}
                                      className="doc-square mr-3 mb-3"
                                    >
                                      <div className="doc-preview">
                                        {isPdf ? (
                                          <div className="pdf-preview">
                                            <i className="fa fa-file-pdf text-danger fa-3x" />
                                            <div className="small mt-1">
                                              PDF Document
                                            </div>
                                          </div>
                                        ) : (
                                          <img
                                            src={doc.documentPath}
                                            alt="Document"
                                            className="doc-image"
                                          />
                                        )}
                                      </div>

                                      <div className="doc-actions">
                                        <Button
                                          color="link"
                                          size="sm"
                                          className="doc-action-btn"
                                          //While API Integration uncomment below code and remove current onClick

                                          // onClick={() =>
                                          //   window.open(
                                          //     doc.documentPath,
                                          //     "_blank",
                                          //   )
                                          // }

                                          onClick={() =>
                                            window.open(
                                              "/Sample Pdf.pdf",
                                              "_blank",
                                            )
                                          }
                                        >
                                          <i className="fa fa-eye mr-1" />
                                          View
                                        </Button>
                                      </div>
                                    </div>
                                  );
                                },
                              )}
                            </div>
                          ) : (
                            <small className="text-muted">
                              No supporting documents uploaded
                            </small>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col md="12">
                <Card>
                  <CardHeader>
                    <h4 className="mb-0">Trainees Added by Channel Partner</h4>
                  </CardHeader>

                  <CardBody>
                    <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
                      {/* Left side - Filter Inputs + Search */}
                      <div className="d-flex flex-wrap align-items-center filter-group">
                        <Input
                          type="text"
                          placeholder="Search by name"
                          value={searchState.searchName}
                          onChange={(e) =>
                            setSearchState((prev) => ({
                              ...prev,
                              searchName: e.target.value,
                            }))
                          }
                          className="mr-2 mb-2 filter-input-large"
                          onKeyDown={handleKeyDown}
                        />

                        <Input
                          type="text"
                          placeholder="Search by email"
                          value={searchState.searchEmail}
                          onChange={(e) =>
                            setSearchState((prev) => ({
                              ...prev,
                              searchEmail: e.target.value,
                            }))
                          }
                          className="mr-2 mb-2 filter-input-large"
                          onKeyDown={handleKeyDown}
                        />

                        <Input
                          type="text"
                          placeholder="Search by mobile no."
                          value={searchState.searchMobile}
                          onChange={(e) =>
                            setSearchState((prev) => ({
                              ...prev,
                              searchMobile: e.target.value,
                            }))
                          }
                          className="mr-2 mb-2 filter-input-large"
                          onKeyDown={handleKeyDown}
                        />

                        <Button
                          color="default"
                          onClick={handleSearch}
                          className="d-flex align-items-center mb-2 filter-btn btn-deep-blue"
                        >
                          <i className="fa fa-search mr-1" />
                          Search
                        </Button>
                        {isFilterApplied && (
                          <Button
                            color="default"
                            className="d-flex align-items-center mb-2 filter-btn btn-deep-blue"
                            onClick={clearSearch}
                          >
                            <i className="fa fa-times mr-1" />
                            Clear
                          </Button>
                        )}
                      </div>
                    </div>
                    <div className="mt-2 mb-3 mx-1">
                      {traineeDataList?.data?.totalFilteredRecords ? (
                        <span className="total-records">
                          Total Records :{" "}
                          {traineeDataList?.data?.totalFilteredRecords}
                        </span>
                      ) : null}
                    </div>
                    {traineeDataList?.data?.totalFilteredRecords === 0 ? (
                      <p className="loaderContainer text-muted">
                        No trainees found
                      </p>
                    ) : (
                      <div className="table-responsive">
                        <CommonTable
                          columns={column}
                          data={formattedTraineeList || []}
                          defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
                          activePage={pageNum}
                          setPageNum={setPageNum}
                          totalPages={Math.ceil(
                            traineeDataList?.data?.totalFilteredRecords /
                              traineeDataList?.data?.noOfRecordsPerPage ||
                              DEFAULT_RECORDS_PER_PAGE,
                          )}
                          showPaginationBottom={true}
                        />
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ChannelPartnerDetail;
